import React from 'react';
import { useNavigate } from 'react-router-dom';

import BusinessIcon from '@material-ui/icons/Business';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import ApartmentIcon from '@material-ui/icons/Apartment';
import ListAltIcon from '@material-ui/icons/ListAlt';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import ReceiptIcon from '@material-ui/icons/Receipt';
import GavelIcon from '@material-ui/icons/Gavel';
import PaymentIcon from '@material-ui/icons/Payment';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import DescriptionIcon from '@material-ui/icons/Description';
import PublicIcon from '@material-ui/icons/Public';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import CategoryIcon from '@material-ui/icons/Category';
import WebIcon from '@material-ui/icons/Web';
import EmailIcon from '@material-ui/icons/Email';
import InfoIcon from '@material-ui/icons/Info';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';



import { getTrans as t } from "../Localization/translations";

const TileSettings = () => {
  const navigate = useNavigate();

  const settingsSections = [
    {
      header: "Profile",
      tiles: [
        { name: "Company Profile", icon: <BusinessIcon />, link: "/profile", desc: "Manage company details" },
        { name: "Subscription", icon: <CreditCardIcon />, link: "/payment", desc: "Manage subscription" },
        { name: "Companies", icon: <ApartmentIcon />, link: "/companies", desc: "Manage companies" },
        { name: "Lines of Business", icon: <ListAltIcon />, link: "/lines-of-business", desc: "Manage LOBs" }
      ]
    },
    {
      header: "Processing",
      tiles: [
        { name: "Import", icon: <CloudUploadIcon />, link: "/import", desc: "Manage bulk data import" },
        { name: "Processing", icon: <SettingsApplicationsIcon />, link: "/processing", desc: "Manage processing" },
        { name: "Approval", icon: <VerifiedUserIcon />, link: "/all-approvals", desc: "Manage approvals" }

      ]
    },
    {
      header: "Accounting",
      tiles: [
        { name: "Accounts", icon: <AccountBalanceWalletIcon />, link: "/accounts", desc: "Manage accounts" },
        { name: "Transactions", icon: <ReceiptIcon />, link: "/transactiontypes", desc: "Manage transactions" },
        { name: "Rules", icon: <GavelIcon />, link: "/accountingsetup", desc: "Manage rules" }
      ]
    },
    {
      header: "Payments",
      tiles: [
        { name: "Subscription (Stripe)", icon: <PaymentIcon />, link: "/paymentstripe", desc: "Manage stripe subscription" },
        { name: "ACH Provider", icon: <AccountBalanceIcon />, link: "/achproviders", desc: "Manage ACH provider details" },
        { name: "ACH Files", icon: <DescriptionIcon />, link: "/achfileview", desc: "View ACH files" }
      ]
    },
    {
      header: "Setting",
      tiles: [
        { name: "Global Setting", icon: <PublicIcon />, link: "/additionalsettings", desc: "Manage global settings" },
        { name: "Party Roles", icon: <GroupAddIcon />, link: "/party-roles", desc: "Manage party roles" }, 
        { name: "Rate Card", icon: <MonetizationOnIcon />, link: "/ratecard", desc: "Manage rate cards" },
        { name: "Tax Rates", icon: <LocalOfferIcon />, link: "/taxrateview", desc: "Manage tax rates" },
        { name: "Inventory Categories", icon: <CategoryIcon />, link: "/categories", desc: "Manage inventory categories" },
        { name: "Expenses Categories", icon: <CategoryIcon />, link: "/expense-categories", desc: "Manage expenses categories" },
        // { name: "Origination Platform", icon: <WebIcon />, link: "/json", desc: "Manage platform settings" },
        { name: "Email Templates", icon: <EmailIcon />, link: "/emailtemplets", desc: "Manage email templates" },
        { name: "Additional Information", icon: <InfoIcon />, link: "/AdditionalFiled", desc: "Manage extra fields" },
        { name: "Terms & Conditions", icon: <GavelIcon />, link: "/term-condition", desc: "Manage Terms & Conditions" }

      ]
    }
  ];

  return (
    <div className="container-fluid p-4" style={{ backgroundColor: '#F0F2F5', minHeight: '100vh' }}>
      {settingsSections.map((section, index) => (
        <div key={index} className="mb-5">
          <h5 className="mb-3 fw-bold" style={{ color: '#44566C' }}>{t(section.header)}</h5>
          <div className="row g-4">
            {section.tiles.map((tile, tIndex) => (
              <div key={tIndex} className="col-12 col-md-6 col-lg-4 col-xl-3">
                <div 
                  className="card h-100 border-0 shadow-sm tile-hover"
                  style={{ cursor: 'pointer', borderRadius: '8px', backgroundColor: '#fff' }}
                  onClick={() => navigate(tile.link)}
                >
                  <div className="card-body d-flex align-items-start p-3">
                    <div className="me-3 mt-1" style={{ color: '#2C5D7E' }}>
                      {React.cloneElement(tile.icon, { fontSize: "large" })}
                    </div>
                    <div>
                      <h6 className="card-title fw-bold mb-1 text-dark">{t(tile.name)}</h6>
                      <p className="card-text text-muted small mb-0">{t(tile.desc)}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      <style jsx>{`
        .tile-hover:hover {
          transform: translateY(-3px);
          box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
        }
      `}</style>
    </div>
  );
};

export default TileSettings;